import { connect } from 'react-redux';

import {
  closeLabelsModal,
  deleteLabel,
  inputDescription,
  inputTitle,
  saveLabel,
  setDuration,
} from '../../actions/labels';
import {
  areLabelsSaving,
  getLabelColor,
  getLabelDescription,
  getLabelDuration,
  getLabelId,
  getLabelTitle,
  getMyPermissions,
  getProjectZoneId,
} from '../../reducers/analyticsApp';
import UpdateLabelModal from '../../components/labels/UpdateLabelModal';
import { staticPermissions } from '../../constants/authorization';

const mapStateToProps = (state) => ({
  id: getLabelId(state),
  title: getLabelTitle(state),
  description: getLabelDescription(state),
  color: getLabelColor(state),
  duration: getLabelDuration(state),
  saving: areLabelsSaving(state),
  zoneId: getProjectZoneId(state),
  hasPermission: getMyPermissions(state).has(staticPermissions.LABELS_MANAGE),
});

const mapDispatchToProps = {
  onTitleChange: inputTitle,
  onDescriptionChange: inputDescription,
  onDurationChange: setDuration,
  onClose: closeLabelsModal,
  onSave: (label) => saveLabel(label),
  onDelete: deleteLabel,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { id, title, color, description, duration } = stateProps;
  const label = { id, title, color, description, duration };

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onSave: () => dispatchProps.onSave(label),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UpdateLabelModal);
